module.exports = __webpack_public_path__ + "media/p_bppair_win.22c92246.mp3";